<template>
  <div>
    <!-- <div class="p" @click="userFlag = !userFlag">申请列表</div> -->
    <transition
      enter-active-class="animated fadeInRight"
      leave-active-class="animated fadeOutRight"
    >
      <div class="userList" v-if="userFlag">
        <div class="title">
          <p>TIPS</p>
          <img src="../assets/newImg/callclose.png" class="close" @click="apply(false)" />
        </div>

        <div class="p">销售代表{{ name }}邀请您加入会议</div>

        <div class="agree" @click="apply(true)">GO</div>

        <div class="refuse" @click="apply(false)">REFUSE</div>
      </div>
    </transition>

    <transition
      enter-active-class="animated fadeInRight"
      leave-active-class="animated fadeOutRight"
    >
      <div class="userList2" v-if="daikanFlag">
        <p>正在进行销售带看</p>
        <img src="../assets/newImg/callclose.png" class="close" @click="close()" />
      </div>
    </transition>
    <!-- <transition
      enter-active-class="animated fadeInRight"
      leave-active-class="animated fadeOutRight"
    >
      <div class="userList2" v-if="daikanFlag">
        <p>正在与{{ name }}进行销售带看</p>
        <img src="../assets/newImg/callclose.png" class="close" @click="close()" />
      </div>
    </transition> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      userFlag: false,
      flag: false,
      name: "",
      id: "",
      daikanFlag: false,
      roomid: "",
    };
  },
  methods: {
    apply(e) {
      let info = {
        msg: "yaoqingapply",
        flag: e,
        data: this.roomid,
        id: this.$chat.role.id,
      };
      let str = 1056 + "," + JSON.stringify(info);
      this.$chat.ws.send(str);

      if (e) {
        document.client.loginOut();
        document.client.join(this.roomid);
        this.daikanFlag = true;
        this.Bus.$emit("daikanFlag", this.daikanFlag);
      }

      this.userFlag = false;
    },

    close() {
      document.client.loginOut();

      let info = {
        msg: "tuichudaikan",
        id: this.$chat.role.id,
      };
      let str = 1056 + "," + JSON.stringify(info);
      this.$chat.ws.send(str);

      this.daikanFlag = false;
      this.Bus.$emit("daikanFlag", this.daikanFlag);
    },
  },
  mounted() {
    this.Bus.$on("yaoqing", (e) => {
      if (this.$chat.role.id == e.data) {
        this.userFlag = true;
        this.roomid = e.num;
        this.name = this.$chat.searchName(e.num);
      }
    });

    this.Bus.$on("tc", (e) => {
      console.log(e);
      if (this.$chat.role.id == e.data) {
        this.$message.error("你已被主持人踢出房间");
        document.client.loginOut();
        this.daikanFlag = false;
        this.Bus.$emit("daikanFlag", this.daikanFlag);
      }
    });

    this.Bus.$on("callapply", (e) => {
      console.log(e);
      if (e.data == this.$chat.role.id) {
        this.callFlag = e.flag;

        if (e.flag == true) {
          this.$message.success("您的销售带看已被接受,可以使用语音视频功能");
          this.daikanFlag = true;

          document.client.loginOut();
          document.client.join(e.num);
        } else {
          this.$message.error("您的销售带看已被拒绝");
          this.daikanFlag = false;
          this.value = 99;
        }

        this.Bus.$emit("daikanFlag", this.daikanFlag);
      }
    });

    this.Bus.$on("callclose", (e) => {
      if (e.data == this.$chat.role.id) {
        this.daikanFlag = false;
        this.$message.error("您的销售带看已结束");
        document.client.loginOut();
        this.value = 99;
      }

      this.Bus.$emit("daikanFlag", this.daikanFlag);
    });
  },
};
</script>

<style lang="scss" scoped>
.userList {
  width: 464.83px;
  height: 164.06px;
  opacity: 0.94;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  background: url("../assets/newImg/callbox.png");
  font-family: BMW Group, BMW Group-Bold;
  .title {
    height: 42px;
    background: url("../assets/newImg/calltitle.png");
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    align-items: center;
    p {
      font-size: 16.01px;

      font-weight: 700;
      text-align: left;
      color: #fff;
    }

    .close {
      width: 21.34px;
      height: 21.34px;
      cursor: pointer;
    }
  }

  .p {
    font-size: 12px;
    font-weight: 700;
    text-align: left;
    color: #415f8c;
    line-height: 35px;
    letter-spacing: 0.96px;
    margin: 0 20px;
  }

  .agree,
  .refuse {
    width: 62.69px;
    height: 37.35px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: BMW Group, BMW Group-Bold;
    color: #fff;
    font-size: 12px;
    cursor: pointer;
  }

  .agree {
    background: url("../assets/newImg/callok.png");
    background-size: 100% 100%;
    position: absolute;
    bottom: 13px;
    right: 88px;
  }
  .refuse {
    background: url("../assets/newImg/callqx.png");
    background-size: 100% 100%;
    position: absolute;
    bottom: 13px;
    right: 12px;
  }
}

.userList2 {
  width: 300px;
  height: 42px;
  opacity: 0.94;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  margin: auto;
  height: 42px;
  background: url("../assets/newImg/calltitle.png");
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  align-items: center;
  color: white;
}

.userList2 {
  width: 300px;
  height: 42px;
  opacity: 0.94;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  margin: auto;
  height: 42px;
  background: url("../assets/newImg/calltitle.png");
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  align-items: center;
  color: white;
}

.icon {
  width: 20px;
  height: 20px;
  background: url("../assets/newImg/callok.png");
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 12px;
}

.close {
  width: 21.34px;
  height: 21.34px;
  cursor: pointer;
}
</style>
